import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserRole } from '../shared/models/userRole';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor( private http: HttpClient) { }

  /** GET isAdmin (determine if logged user has admin role). Will 404 if not found */
  getUserRole(): Observable<UserRole> {
    return this.http.get<UserRole>('userrole').pipe(
      catchError(this.handleError<UserRole>(`get UserRole`))
    );
  }

  /** Set last viewed time. Will 404 if not found */
  updateLastViewed(): Observable<any> {
    return this.http.get<any>('lastviewed').pipe(
      catchError(this.handleError<any>(`update last viewed`))
    );
  }

  /** Logout user. Will 404 if not found */
  logout(): Observable<any> {
    return this.http.get<any>('userlogout', {observe: 'response'}).pipe(
      catchError(this.handleError<any>(`log out user`))
    );
  }
  
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
   private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
